define('GameDayCore/GDModel/ValueObjects/RealTimeHighlights/RealTimeHighlightKeyword',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(RealTimeHighlightKeyword);

	function RealTimeHighlightKeyword($data) {
		var vo = VO.ensureVO(this, RealTimeHighlightKeyword),
			data = $data;

	    vo.type = data.type || "";
        vo.value = data.value || "";

	}

	return RealTimeHighlightKeyword;
});
